import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../lang';
import HelperService from '../../services/HelperService';
import Icon, { Icons } from '../Icon/Icon';
import { ListItemTextWithSkeleton } from '../Skeletons/ItemsWithSkeleton';
import './Copy.scss';

const ICON_SIZE_COPY = 24;

const Copy = ({ loading = false, title, description, copyText }) => {
	const copy = () => {
		navigator.clipboard.writeText(copyText);

		HelperService.showNotification({
			icon: 'DOCUMENTS_ICON_PURPLE',
			title: t('Address copied'),
			description: HelperService.middleEllipsis(copyText),
			iconSize: 32,
		});
	};

	return (
		<div className='Copy FormBlock'>
			<ListItemTextWithSkeleton
				title={title}
				description={description}
				trailing={[<Icon type={Icons.DOCUMENTS_ICON} width={ICON_SIZE_COPY} height={ICON_SIZE_COPY} />]}
				onSelect={copy}
				loading={loading}
				items={[1]}
				skeletonCount={1}
			/>
		</div>
	);
};

Copy.propTypes = {
	loading: PropTypes.bool,
	title: PropTypes.oneOfType([PropTypes.number, PropTypes.node]),
	description: PropTypes.string,
	copyText: PropTypes.string.isRequired,
};

export default Copy;
